/**
 * 创建人：王靖
 * 时间：2019-3-11
 * 描述：为图片预览功能提供服务:创建和销毁预览组件
 * 更新记录: 
 */
import { Injectable, Injector, ApplicationRef, ComponentFactoryResolver } from "@angular/core";
import { SwPhotoAlbumComponent } from "./sw-photo-album.component";


/**
 * 图片的预览功能
 */
@Injectable()
export class SwPhotoAlbumService {

    /**
     * @ignore
     */
    constructor(private injector: Injector,
        private applicationRef: ApplicationRef,
        private componentFactoryResolver: ComponentFactoryResolver){}

    /**
     * 动态创建图片预览
     * @param photos  { path :["绝对地址","",""]，index：3}
     * @param autoPlay  是否开启轮播 默认为false
     * @param intervalTime  轮播间隔 默认3秒
     */
    showPhotoAlbum(photos: any,autoPlay=false,intervalTime=3000){
        //创建dom节点
        const popup = document.createElement("sw-photo-album-component");
        //创建动态组件
        const factory = this.componentFactoryResolver.resolveComponentFactory(SwPhotoAlbumComponent);
        const swPhotoAlbumComponentRef = factory.create(this.injector, [], popup);
        this.applicationRef.attachView(swPhotoAlbumComponentRef.hostView);

        //组件的关闭事件
        swPhotoAlbumComponentRef.instance.voted.subscribe(()=>{
            document.body.removeChild(popup);
            this.applicationRef.detachView(swPhotoAlbumComponentRef.hostView);
            swPhotoAlbumComponentRef.destroy()
        });
        //传递参数
        swPhotoAlbumComponentRef.instance.photosData = photos;
        swPhotoAlbumComponentRef.instance.autoPlay = autoPlay;
        swPhotoAlbumComponentRef.instance.intervalTime = intervalTime;

        document.body.appendChild(popup);
    }
}

